// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICustomPageable } from './ICustomPageable';
import {
    ICustomPageableFromJSON,
    ICustomPageableFromJSONTyped,
    ICustomPageableToJSON,
    ICustomPageableToJSONTyped,
} from './ICustomPageable';
import type { ITaxFormInfoDto } from './ITaxFormInfoDto';
import {
    ITaxFormInfoDtoFromJSON,
    ITaxFormInfoDtoFromJSONTyped,
    ITaxFormInfoDtoToJSON,
    ITaxFormInfoDtoToJSONTyped,
} from './ITaxFormInfoDto';

/**
 * 
 * @export
 * @interface ICustomPageTaxFormInfoDto
 */
export interface ICustomPageTaxFormInfoDto {
    /**
     * 
     * @type {number}
     * @memberof ICustomPageTaxFormInfoDto
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageTaxFormInfoDto
     */
    size?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageTaxFormInfoDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageTaxFormInfoDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageTaxFormInfoDto
     */
    empty?: boolean;
    /**
     * 
     * @type {Array<ITaxFormInfoDto>}
     * @memberof ICustomPageTaxFormInfoDto
     */
    content?: Array<ITaxFormInfoDto>;
    /**
     * 
     * @type {ICustomPageable}
     * @memberof ICustomPageTaxFormInfoDto
     */
    pageable?: ICustomPageable;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageTaxFormInfoDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageTaxFormInfoDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageTaxFormInfoDto
     */
    total_elements?: number;
}

/**
 * Check if a given object implements the ICustomPageTaxFormInfoDto interface.
 */
export function instanceOfICustomPageTaxFormInfoDto(value: object): value is ICustomPageTaxFormInfoDto {
    return true;
}

export function ICustomPageTaxFormInfoDtoFromJSON(json: any): ICustomPageTaxFormInfoDto {
    return ICustomPageTaxFormInfoDtoFromJSONTyped(json, false);
}

export function ICustomPageTaxFormInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICustomPageTaxFormInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'] == null ? undefined : json['number'],
        'size': json['size'] == null ? undefined : json['size'],
        'last': json['last'] == null ? undefined : json['last'],
        'first': json['first'] == null ? undefined : json['first'],
        'empty': json['empty'] == null ? undefined : json['empty'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(ITaxFormInfoDtoFromJSON)),
        'pageable': json['pageable'] == null ? undefined : ICustomPageableFromJSON(json['pageable']),
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
    };
}

export function ICustomPageTaxFormInfoDtoToJSON(json: any): ICustomPageTaxFormInfoDto {
    return ICustomPageTaxFormInfoDtoToJSONTyped(json, false);
}

export function ICustomPageTaxFormInfoDtoToJSONTyped(value?: ICustomPageTaxFormInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'last': value['last'],
        'first': value['first'],
        'empty': value['empty'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(ITaxFormInfoDtoToJSON)),
        'pageable': ICustomPageableToJSON(value['pageable']),
        'totalPages': value['total_pages'],
        'numberOfElements': value['number_of_elements'],
        'totalElements': value['total_elements'],
    };
}

